<template lang="pug">
    v-dialog(persistent class="justify-center" width="500" v-model="show" :disabled="!available")
        v-btn.white--text(:id="activatorId" slot="activator" color="success" round large :disabled="!available") {{confirmMessage}}
        
        v-card
            v-card-title.text-xs-center.headline(class="grey lighten-2" primary-title) {{title}}
            v-card-text
                slot
                supervisor-unique-key(@exit="handleCancel()" ref="keyform" @check-key="checkKey")
            v-card-actions(pa-3)
                v-btn.white--text(color="red" round large md-4
                @click="handleCancel()") Cancelar
                v-spacer
                v-btn.white--text(color="indigo" round large auto
                @click="checkKey"
                :disabled="!filledCode") Confirmar
</template>

<script>
import SupervisorUniqueKey from '@/components/SupervisorUniqueKey/SupervisorUniqueKey'
import Colors from '@/mixins/Colors'
import { mapState, mapActions } from 'vuex'
export default {
    name: 'supervisor-unique-key-modal',
    props: {
        /**
         * @description makes button to show modal disabled if false, abled if true.
         */
        available: {
            type: Boolean,
            default: () => false,
        },
        /**
         * @description title shown in the v-card-title section of the modal.
         */
        title: {
            type: String,
            default: () => '',
        },

        /**
         * @description
         */
        showModal: {
            type: Boolean,
            default: () => false,
        },

        confirmMessage: {
            type: String,
            default: () => 'Confirmar',
        },

        activatorId: {
            type: String,
            default: 'supervisor-modal-button',
        },
        // confirmKey: {
        //     type: String,
        //     default: null
        // }
    },
    data: function() {
        return {
            show: false, // decides if modal is shown or not.
        }
    },
    computed: {
        ...mapState('UniqueKeyModule', {
            uniqueKey: 'uniqueKey',
            permission: 'permission',
        }),

        // showModal: {
        //     get: function(){
        //         return false
        //     },
        //     set: function(newVal){
        //         return newVal
        //     }
        // },

        filledCode: function() {
            return this.uniqueKey.length === 12
        },
    },
    methods: {
        ...mapActions('UniqueKeyModule', {
            resetStateUniqueKeyModule: 'resetState',
        }),

        checkKey() {
            if (this.uniqueKey.length === 12) {
                this.$emit('check-key')
                this.show = false
            }
        },

        cleanForm() {
            this.showModal = false
            this.resetStateUniqueKeyModule()
            this.$emit('clearform')
        },
        handleCancel() {
            this.show = false
            this.$emit('closed')
        },
    },
    mixins: [Colors],
    components: { SupervisorUniqueKey },

    watch: {
        show(newVal, oldVal) {
            this.$emit('change-visibility-modal', newVal)
            this.$refs.keyform.focus()
        },

        showModal(newVal, oldVal) {
            this.show = newVal
        },
    },
}
</script>

<style lang="scss"></style>
